/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { AmoxcalliAttendanceStatus } from '../../models/amoxcalli-attendance-status';
import { AmoxcalliRegisterAttendanceByQrDto } from '../../models/amoxcalli-register-attendance-by-qr-dto';

export interface ApiAttendanceScanPost$Plain$Params {
      body?: AmoxcalliRegisterAttendanceByQrDto
}

export function apiAttendanceScanPost$Plain(http: HttpClient, rootUrl: string, params?: ApiAttendanceScanPost$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<AmoxcalliAttendanceStatus>> {
  const rb = new RequestBuilder(rootUrl, apiAttendanceScanPost$Plain.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<AmoxcalliAttendanceStatus>;
    })
  );
}

apiAttendanceScanPost$Plain.PATH = '/api/attendance/scan';
